import { render, staticRenderFns } from "./sku-editor-table.vue?vue&type=template&id=6d24ea99&"
import script from "./sku-editor-table.vue?vue&type=script&lang=js&"
export * from "./sku-editor-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports